import { SelectionModel } from '@angular/cdk/collections';
import { IAumMenuItemPerRow } from '../../pattern';

export interface ITableDelegate {
    onMenuClicked?(selectedRowsNum: Number): void;
    onRowButtonClicked(id: string, action?: string): void;
    onMenuItemClick(action: string, selectedRows: SelectionModel<any>): void;
    onSingleRowSelection?(id: string, checked: boolean): void;
}

export interface ITableDelegateWithRowActions extends ITableDelegate {
    onMenuItemPerRowClick(action: string, row: any, item?: IAumMenuItemPerRow, event?: Event): void;
}
